import React, { Dispatch } from 'react';
import cn from 'classnames';
import { BaseModal } from '@repo/components/modals';
import { capitalize } from '@repo/utils/helpers/string';
import { AuthPlatform } from '@repo/utils/helpers/jwt';
import { loginWithProvider } from './OAuthLogins';

function formatProvider(provider: AuthPlatform) {
  if (provider === 'sso') {
    return 'SSO';
  }

  return capitalize(provider);
}

export default function LoginErrorModal({
  onClose,
  message,
  open,
  provider = undefined,
  setSigningInWith,
}: {
  onClose: () => void;
  message: string;
  open: boolean;
  provider?: AuthPlatform;
  setSigningInWith: Dispatch<'google' | 'apple' | 'email' | 'sso' | null>;
}) {
  let title = 'Error signing in';
  let showCreateAccountBtn = false;

  if (provider) {
    title = `Error signing in with ${formatProvider(provider)}`;
  }

  // Not sure if this error message string is still in use...
  if (message?.startsWith('Please sign into')) {
    title = `${capitalize(provider)} Account Not Found`;
  }

  if (message?.startsWith('An account for this login method does not exist')) {
    title = `${capitalize(provider)} Account Not Found`;
    showCreateAccountBtn = true;
  }

  return (
    <BaseModal isOpen={open} onRequestClose={onClose}>
      <div className="modal-header">{title}</div>
      <div className="modal-content-padded">{message}</div>
      <div className="modal-content-padded">
        {showCreateAccountBtn && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              loginWithProvider(setSigningInWith, provider, true);
              onClose();
            }}
          >
            Create Account
          </button>
        )}
        <button
          type="button"
          className={cn('btn', showCreateAccountBtn ? 'btn-secondary' : 'btn-primary')}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </BaseModal>
  );
}
